import { createContext, useContext, useState, useCallback } from "react";

// Jezicki kontekst — pamti izbor (sr/en) za celu aplikaciju.
const LanguageContext = createContext({
  lang: "sr",
  toggle: () => {},
  setLang: () => {},
});

const STORAGE_KEY = "na_lang";

function getInitialLang() {
  if (typeof window === "undefined") return "sr";
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved === "sr" || saved === "en") return saved;
  } catch (e) {
    // localStorage nedostupan — koristi default
  }
  return "sr";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(getInitialLang);

  const persist = useCallback((next) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch (e) {
      // ignore
    }
  }, []);

  const setLang = useCallback(
    (next) => {
      const value = next === "en" ? "en" : "sr";
      setLangState(value);
      persist(value);
    },
    [persist]
  );

  const toggle = useCallback(() => {
    setLangState((prev) => {
      const next = prev === "sr" ? "en" : "sr";
      persist(next);
      return next;
    });
  }, [persist]);

  return (
    <LanguageContext.Provider value={{ lang, toggle, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
